import { Pie } from '@ant-design/plots'
import { legend } from '@antv/g2plot/lib/adaptor/common'

const PieChart = ({ data, angle, color, name }) => {
  const idToNameMap = Object.fromEntries(data.map(item => [item.id, item.name]))
  const config = {
    appendPadding: 10,
    color: [
      '#2459A8',
      '#ABC5ED',
      '#FF708B',
      '#FFB969',
      '#44D6B5',
      '#96EDCC',
      '#32C3FD',
    ],

    data,
    angleField: angle,
    colorField: 'id',

    radius: 1,
    innerRadius: 0.6,
    label: {
      type: 'inner',
      offset: '-50%',
      content: '{value}',
      style: {
        textAlign: 'center',
        fontSize: 11,
      },
    },
    legend: {
      position: 'right',
      itemName: {
        formatter: text => {
          return idToNameMap[text] || text
        },
      },
    },
    interactions: [
      {
        type: 'element-selected',
      },
      {
        type: 'element-active',
      },
    ],
    tooltip: {
      formatter: datum => ({
        name: idToNameMap[datum.id] || datum.id,
        value: datum[angle],
      }),
    },
    statistic: {
      title: false,

      content: {
        style: {
          whiteSpace: 'pre-wrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        content: `<h4 className="text-10px">${name}</h4>`,
      },
    },
  }
  return <Pie {...config} />
}
export default PieChart
